export default {
  answerQuestionOne: 'answerQuestionOne',
  answerQuestionTwo: 'answerQuestionTwo',
}
